// extracted by mini-css-extract-plugin
module.exports = {"assessment-form__list":"self-assessment-form_assessment-form__list__7qM3K"};